import React, { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n, translateTimeline } from "../lib/i18n";
import { fmtDate } from "../lib/format";

export default function Audit() {
  const { t } = useI18n();
  const [logs, setLogs] = useState([]);
  const [moduleFilter, setModuleFilter] = useState("");
  const [actionFilter, setActionFilter] = useState("");

  const load = useCallback(async () => {
    const qs = new URLSearchParams();
    if (moduleFilter) qs.set("module", moduleFilter);
    if (actionFilter) qs.set("action", actionFilter);
    const { data } = await api.get(`/audit?${qs}`);
    setLogs(data);
  }, [moduleFilter, actionFilter]);

  useEffect(() => {
    void load();
  }, [load]);

  const MODULES = ["", "auth", "documents", "evidences", "occurrences", "finance", "routes", "commissions", "tenants", "sectors", "webhooks", "push"];

  return (
    <div className="space-y-4">
      <div className="card-soft px-5 py-4">
        <div className="text-xs text-[var(--text-2)] font-medium">Compliance</div>
        <h1 className="font-display text-2xl font-bold tracking-tight mt-0.5">{t("nav_audit")}</h1>
        <p className="text-xs text-[var(--text-2)] mt-1">Trilha imutável de auditoria — nenhum registro pode ser removido.</p>
      </div>

      <div className="flex gap-2 flex-wrap">
        {MODULES.map((m) => (
          <button
            key={m || "all"}
            onClick={() => setModuleFilter(m)}
            className={`px-4 h-9 rounded-2xl text-xs font-semibold transition ${moduleFilter === m ? "bg-[var(--brand)] text-white" : "bg-[var(--surface)] border border-[var(--border-c)] hover:bg-[var(--brand-soft)] hover:text-[var(--brand)]"}`}
            data-testid={`audit-module-${m || "all"}`}
          >
            {m ? translateTimeline(t, "audit_module", m) : t("audit_all")}
          </button>
        ))}
      </div>

      <div className="card-soft overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[var(--surface-2)] border-b border-[var(--border-c)]">
              <tr className="text-left text-xs text-[var(--text-2)] font-semibold">
                <th className="px-4 py-3">{t("audit_when")}</th>
                <th className="px-4 py-3">{t("audit_user")}</th>
                <th className="px-4 py-3">{t("audit_module")}</th>
                <th className="px-4 py-3">{t("audit_action")}</th>
                <th className="px-4 py-3">{t("audit_entity")}</th>
                <th className="px-4 py-3">IP</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 && <tr><td colSpan={6} className="text-center py-10 text-[var(--text-2)]">{t("no_data")}</td></tr>}
              {logs.map((l) => (
                <tr key={l.id} className="border-b border-[var(--border-c)] hover:bg-[var(--surface-2)]" data-testid={`audit-row-${l.id}`}>
                  <td className="px-4 py-3 font-mono text-xs text-[var(--text-2)]">{fmtDate(l.timestamp)}</td>
                  <td className="px-4 py-3 font-mono text-xs">{l.user_email || "—"}</td>
                  <td className="px-4 py-3"><span className="pill pill-neutral">{translateTimeline(t, "audit_module", l.module)}</span></td>
                  <td className="px-4 py-3 font-mono text-xs text-[var(--brand)] font-semibold">{l.action}</td>
                  <td className="px-4 py-3 font-mono text-xs text-[var(--text-2)]">{l.entity_type}/{l.entity_id?.slice(0, 8)}</td>
                  <td className="px-4 py-3 font-mono text-[10px] text-[var(--text-2)]">{l.ip || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
